<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import TransitionWrapper from '@/layout/wrappers/transition-wrapper'
import TheMenu from '@/layout/the-menu'
import FeedbackForm from '@/pages/contacts/feedback-form'

export default {

  name: 'ThePopup',

  components: {
    TransitionWrapper,
    FeedbackForm,
    TheMenu
  },

  computed: {
    isMenuOpened () {
      return this.$store.state.menu.opened
    },

    isFormOpened () {
      return this.$store.state.form.opened
    },

    isPopupOpened () {
      return this.$store.getters.isPopupOpened
    }
  },

  methods: {
    onAnimationStart () {
      this.$store.commit('popupAnimationStart')
    },

    onAnimationEnd () {
      this.$store.commit('popupAnimationEnd')
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

.popup(:class="{ 'is-opened': isPopupOpened }")

  transition-wrapper(@transition-start="onAnimationStart" @transition-end="onAnimationEnd")
    the-menu(v-if="isMenuOpened")

  transition-wrapper(@transition-start="onAnimationStart" @transition-end="onAnimationEnd")
    feedback-form(v-if="isFormOpened")

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>

.popup
  position fixed
  top 0
  left 0
  display flex
  width 100%
  height 100%
  pointer-events none

  &.is-opened
    pointer-events auto

</style>



// WEBPACK FOOTER //
// the-popup.vue?2e0289d1